<template>
  <div class="main-content">

    <sideBarOrderModal
      v-if="orderModalData.open"
      :modalData="orderModalData"
      :onModalClose="closeModal"
    />

    <PhoneBlackListEditModal
      v-if="editBlackList.open"
      :newRecord="editBlackList.record"
      :onCancel="closeBlackList"
    />

    <div class="card">
      <div class="card-body">
        <form @submit.prevent="gerRecords">
          <div class="range_picker flex">
            <div class="form-group mr-1">
              <label for="" class="d-block">Период</label>
              <date-range-picker
                ref="picker"
                :startDate="startDate"
                opens="right"
                :ranges="ranges"
                :locale-data="date_locale"
                v-model="dateRange"
              >
              </date-range-picker>
            </div>
            <div class="form-group mr-1">
              <label for="" class="d-block">Проект</label>
              <CustomMultiSelect
                ref="selectedProjects"
                :records="Object.values($AllProjects).filter((p) => p.is_active).map((p) => {return {...p, selectTitle: p.name}})"
                :options="{placeholder: 'Выберите проект'}"
              />
            </div>
            <div class="form-group mr-1">
              <label for="" class="d-block">Тип заявок</label>
              <select v-model="searchFilter.order_type" class="form-control">
                <option value="0">Все заявки</option>
                <option value="1">Курьерские</option>
                <option value="2">Почтовые</option>
              </select>
            </div>
            <div class="form-group mr-2">
              <label for="">Номер телефона</label>
              <input v-model="phoneNum" class="form-control" placeholder="Номер телефона"/>
            </div>
            <div class="form-group mr-1 flex flex-column">
              <label><input v-model="searchFilter.status" value="0" type="radio"> Все статусы</label>
              <label><input v-model="searchFilter.status" value="1" type="radio"> Только доставленые</label>
              <label><input v-model="searchFilter.status" value="2" type="radio"> Только отмененные</label>
            </div>
          </div>
          <div class="text-right">
            <LoadingButton
              title="Показать"
              className="btn btn-success btn-xs"
              type="submit"
              :onClick="() => {}"
              :loading="loading"
            />
          </div>
        </form>
      </div>
    </div>

    <pulse-loader :loading="loading" :color="loadingColor" class="text-center"/>

    <div class="card" v-if="!loading">
      <div class="card-body">

        <div v-if="paginator" class="text-right">
          <p>Всего записей <strong>{{ paginator.total }}</strong></p>
        </div>

        <table class="table table-sm table-hover">
          <thead>
          <tr>
            <th>№</th>
            <th></th>
            <th>с номера</th>
            <th>на номер</th>
            <th>Пользователь</th>
            <th>Клиент</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(record, index) in records">
            <td>{{
                (index + 1) + (paginator.current_page !== 1 ? (paginator.current_page * paginator.per_page - paginator.per_page) : 0)
              }}
            </td>
            <td>
              <template v-if="record.type_id === 1">
                <i class="icon-fa icon-fa-arrow-left green"></i>
              </template>
              <template v-else>
                <i class="icon-fa icon-fa-arrow-right blue"></i>
              </template>
              <p class="text-muted fs-10">{{ record.id }}</p>
            </td>
            <td>
              <p>
                <span v-bind:class="{active: record.phone_title === searchPhone}">{{ record.phone_title }}</span>
              </p>
              <p v-if="record.type_id === 1 && !record.call_duration" class="badge badge-warning">пропущенный вызов</p>
              <p class="badge badge-info" v-if="record.type_id === 2 && lines[record.phone_title]">
                <!--                ({{ $AllProjects[lines[record.phone_title].project_id].name }} : {{ $AllCities[lines[record.phone_title].city_id].short_name }})-->
                {{ lines[record.phone_title].description }}
              </p>
            </td>
            <td>
              <p>
                <span v-bind:class="{active: record.destination === searchPhone}">{{ record.destination }}</span>
              </p>
              <p class="badge badge-info" v-if="record.type_id === 1 && lines[record.destination]">
                <!--                ({{ getPhoneTitle(record, 'destination') }})-->
                <!--                <template v-if="record.extension_id">-->
                {{ lines[record.destination].description }}
                <!--                </template>-->
              </p>
            </td>
            <td>
              {{ users[record.user_id] || 'не определен' }}
              <template v-if="record.call_duration">
                <p><strong>{{ record.call_duration }}</strong> секунд</p>
              </template>
            </td>
            <td>
              <template v-if="record.client">
                <p>{{ record.client.name }}</p>
                <p v-if="record.client.email">{{ record.client.email }}</p>
              </template>
              <template v-if="record.order">
                {{ record.order.id }}
                <button
                  @click="openOrderInModal(record.order.id)"
                  class="btn btn-xs btn-info newWindowBtn mr-1"
                >
                  <i class="icon-fa icon-fa-eye"></i>
                </button>
              </template>
              <template v-if="blackList[record.id]">
                <button @click="() => {editBlackList = {open: true, record: blackList[record.id]}}"
                        v-bind:class="{'btn btn-xs pointer': true, 'btn-danger': blackList[record.id].is_active, 'btn-dark': !blackList[record.id].is_active}">
                  {{ blackList[record.id].is_active ? 'черный' : 'серый' }} список
                </button>
              </template>

            </td>
            <td>
              <template v-if="record.file_link">
                <button @click="showRecord(record.id)" v-if="!showFileRecord[record.id]"
                        class="btn btn-outline-info btn-xs">Показать запись
                </button>
                <template v-if="showFileRecord[record.id]">
                  <audio controls v-if="record.file_link">
                    <source
                      :src="`https://admin.rancond.info/api/noa/mangoRecord/${record.id}`"
                      type="audio/mpeg"
                    />
                    Your browser does not support the audio tag.
                  </audio>
                </template>
              </template>
              <p>{{ printDate(record.created_at, 'DD.MM.YYYY HH:mm') }}</p>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="pull-right">
          <paginate v-if="paginator"
                    v-model="paginator.current_page"
                    :page-count="paginator.last_page"
                    :page-range="3"
                    :margin-pages="2"
                    :click-handler="gerRecords"
                    :prev-text="'&laquo'"
                    :next-text="'&raquo'"
                    :container-class="'pagination'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :active-class="'active green_btn'">
          </paginate>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import api from "@/api";
import moment from "moment";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import LoadingButton from "@/components/buttons/LoadingButton";
import Paginate from 'vuejs-paginate'
import sideBarOrderModal from "@/components/modals/orders/sideBarOrderModal";
import PhoneBlackListEditModal from "@/components/clients/PhoneBlackListEditModal";
import CustomMultiSelect from "@/components/selects/CustomMultiSelect.vue";

export default {
  components: {
    CustomMultiSelect,
    LoadingButton,
    DateRangePicker,
    sideBarOrderModal,
    PhoneBlackListEditModal,
    Paginate,
  },
  computed: {
    $AllCities() {
      return this.$store.getters["platform/cities"];
    },
    $AllProjects() {
      const projects = this.$store.getters["platform/projects"].reduce(
        (acc, p) => {
          acc[p.id] = {...p};
          return acc;
        },
        {}
      );
      return projects;
    }
  },
  data() {
    return {
      loading: false,
      loadingColor: this.$constants.LOADING_COLOR,
      phoneNum: null,
      searchPhone: null,
      records: null,
      paginator: null,
      orderModalData: {},
      users: {},
      lines: {},
      searchFilter: {order_type: 0, status: 0},
      editBlackList: {},
      openBlackList: {},
      blackList: {},
      showFileRecord: {},
      dateRange: {
        startDate: moment().subtract(3, 'month'),
        endDate: moment(),
      },
      startDate: '2021-01-01',
      date_locale: {
        firstDay: 1,
        format: 'DD.MM.YYYY',
        applyLabel: 'Выбрать',
        cancelLabel: 'Отмена',
      },
      ranges: { //default value for ranges object (if you set this to false ranges will no be rendered)
        'Сегодня': [moment(), moment()],
        'Вчера': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Текущая неделя': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
        'Прошлая неделя': [moment().subtract(1, 'isoWeek').startOf('isoWeek'), moment().subtract(1, 'isoWeek').endOf('isoWeek')]
      },
    }
  },
  mounted() {
    this.getCallsData();
  },
  methods: {
    closeBlackList() {
      this.editBlackList = {};
    },
    async getCallsData() {
      const {data} = await api.index('/telephony/callHistoryData');
      if (data.success) {
        this.users = data.users;
        this.lines = data.lines;
      } else {
        toastr['warning']('Ошибка сервера');
      }
    },
    getPhoneTitle(record, title) {
      let phoneTitle;
      let key;
      if (record.extension_id) {
        key = record.extension_id
      } else {
        key = Object.keys(this.lines[record[title]])[0];
      }
      phoneTitle = this.$AllProjects[this.lines[record[title]][key].project_id].name + ':'
        + this.$AllCities[this.lines[record[title]][key].city_id].short_name;
      return phoneTitle;
    },
    showRecord(id) {
      this.$set(this.showFileRecord, id, true);
    },
    openOrderInModal(orderId) {
      this.orderModalData = {
        orderId: orderId,
        open: true
      };
    },
    closeModal() {
      this.orderModalData = {open: false};
    },
    async gerRecords(page = 1) {
      if (this.loading) return;
      this.loading = true;
      let {data: r_data} = await api.post('/telephony/getCalls', {
        page: page,
        range: this.dateRange,
        phone: this.phoneNum,
        filter: {...this.searchFilter, selected_projects: this.$refs.selectedProjects.selectedRecords.map((p) => p.id)}
      });
      if (r_data.success) {
        this.paginator = null;
        const {data, ...pagination} = r_data.records
        this.paginator = pagination
        this.records = data
        this.searchPhone = r_data.phone;
        this.setBlackList(r_data.blackList);
      } else {
        toastr['warning'](r_data.message || 'Ошибка сервера');
      }
      this.loading = false;
    },
    setBlackList(list) {
      const blackList = list.reduce((acc, b) => {
        acc[b.phone_num.substr(2)] = b;
        return acc;
      }, {});
      this.blackList = this.records.reduce((acc, r) => {
        let index;
        if (r.type_id === 2) {
          if (blackList[r.destination]) {
            index = r.destination
          }
        } else {
          if (blackList[r.phone_title]) {
            index = r.phone_title
          }
        }
        acc[r.id] = blackList[index];
        return acc;
      }, {});
    }
  }
}
</script>

<style scoped>
.flex-column label {
  margin-bottom: 0;
}

input.form-control,
select.form-control,
.vue-daterange-picker {
  height: 42px;
}

.btn.btn-xs {
  padding: 2px 5px !important;
}

span.active {
  background-color: #ccdcff;
  padding: 3px;
}

.icon-fa.green {
  color: green;
}

.icon-fa.blue {
  color: blue;
}

audio {
  height: 25px;
}

.fs-10 {
  font-size: 10px;
}

table.table p {
  margin-bottom: 2px;
}
</style>
